import {Injectable} from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/internal/operators/catchError';
import { WorkflowService } from 'app/shared/services/workflow.service';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private workflowService: WorkflowService, private router: Router, private toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    var accessToken = this.workflowService.GetAccessToken();
    
    let headers = new HttpHeaders();
    if(!req.url.includes("https://plus.codes/api")) {
      headers = req.headers.set('Authorization', `Bearer ${accessToken}`);
    }
    const authReq = req.clone({ headers });

    return next.handle(authReq).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            if (!this.router.url.includes("/home/security") && !this.router.url.includes("/home/login")) {
              this.toastr.error("Su sesión ha expirado.", "Error");
              this.workflowService.Reset();
            }
          }
          if([404,503,0].includes(error.status)){
            this.router.navigate(['/service-unavalaible'])
            return;
          }
        }
        return throwError(error);
      })
    );
  }
}
